import axiosConfig from "./axiosConfig";
import { Lead } from "./getLeads";

export interface UpdateLeadDecisionsRequest {
  polygonDecision?: Record<string, unknown> | null;
  landlordDecision?: Record<string, unknown> | null;
  tenantDecision?: Record<string, unknown> | null;
  ownerOccupier?: boolean;
  // A building the operator picked off-list (clicked an OSM building via
  // "Show all available buildings" that the resolver never offered). The
  // BE appends it to the lead's polygon_candidates so polygonDecision's
  // acceptedBkey resolves + site creation can read its geometry.
  newPolygonCandidate?: Record<string, unknown> | null;
}

export interface UpdateLeadDecisionsResponse {
  lead: Lead;
}

const patchLeadDecisions = async (
  authToken: string,
  leadId: string,
  body: UpdateLeadDecisionsRequest
): Promise<UpdateLeadDecisionsResponse> => {
  const { data } = await axiosConfig.patch(
    `/leads/${leadId}/decisions`,
    body,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default patchLeadDecisions;
